import { FeatureCollection } from 'geojson'
import { MS_UUID } from 'map-style-utils'
import { Source } from 'ms-map-gl'
import { FC } from 'react'

import { HeatmapLayer } from '../../Layers/HeatmapLayer'
import { CategoryLayer } from '../../Layers/MarkerLayer/Category'
import { PointLayer } from '../../Layers/MarkerLayer/Point'

import { LAYER_TYPES, useLayerType } from '~map-preview/states/layerType'
import {
  MARKER_TYPES,
  useMarkerCategory,
  useMarkerType
} from '~map-preview/states/marker'
import { geojsonify } from '~map-preview/utils/geojsonify'

const DEFAULT_SOURCE_ID = 'mapstack-points'
const DEFAULT_TYPE = 'geojson'

type GeojsonSourceProps = {
  geojson?: FeatureCollection
}

export const GeojsonSource: FC<GeojsonSourceProps> = geojsonify((props) => {
  const { geojson } = props

  const layerType = useLayerType()
  const markerType = useMarkerType()
  const markerCategory = useMarkerCategory()

  return (
    <Source
      id={DEFAULT_SOURCE_ID}
      type={DEFAULT_TYPE}
      data={geojson}
      promoteId={MS_UUID}
    >
      {layerType === LAYER_TYPES.HEATMAP && <HeatmapLayer />}

      {layerType === LAYER_TYPES.MARKER &&
        markerType === MARKER_TYPES.INDIVIDUAL && <PointLayer />}

      {layerType === LAYER_TYPES.MARKER &&
        markerType === MARKER_TYPES.CATEGORIES &&
        markerCategory && <CategoryLayer geojson={geojson} />}
    </Source>
  )
})
